window.addEventListener('DOMContentLoaded', () => {
  const psiForm = document.getElementById('psi-form');
  if (psiForm) {
    handleChange(psiForm);
    psiForm.addEventListener('freeform-ajax-success', function (event) {
      startEventPsiForm();
    });
  }
});

function handleChange(psiForm) {
  const psiOptions = psiForm.querySelectorAll("[name='requerimiento[]']");
  if (!psiOptions.length) return;

  const hiddenInput = document.getElementById('describeTuNecesidad');
  const otroValue = 'buscoOtroServicio';

  const handleOptionChange = (event) => {
    const currentCheckbox = event.target;
    const isChecked = currentCheckbox.checked;

    if (currentCheckbox.value === otroValue && isChecked) {
      console.log('hi');
      hiddenInput.classList.remove('d-none');
    } else {
      hiddenInput.classList.add('d-none');
    }

    if (isChecked) {
      psiOptions.forEach((option) => {
        if (option !== currentCheckbox) {
          option.disabled = true;
        }
      });
    } else {
      psiOptions.forEach((option) => {
        option.disabled = false;
      });
    }
  };

  psiOptions.forEach((option) => {
    option.addEventListener('change', handleOptionChange);
  });
}


function startEventPsiForm () {
  try {
    gtag("event", "submit", {
      event_category: "formularios",
      event_label: "submit",
      event_value: "contacto_formulario_psi",
    });
  } catch (Exception) {
    console.warn("Exception in GA Events => " + Exception);
  }
}